module.exports = __webpack_public_path__ + "static/img/fefco205_1.78456f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco205_1.png
// module id = fMMW
// module chunks = 0